import { useState } from 'react';
import '../App.scss';
import { Button } from '@mui/base/Button';
import { TextField, FormControlLabel, Switch  } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import { UserClient, UserModel } from '../types';
import { createClient } from "../api/clients";

function CreateUser() {
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isEnabled, setIsEnabled] = useState(true);
  const [isLead, setIsLead] = useState(false);

  const navigate = useNavigate();
    const userClient = createClient(UserClient);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setErrorMessage(null);

    const user: UserModel = { name, role, email, isEnabled, isLead };

    try {
      const result = await userClient.createUser(user);

      if (result.success === false) {
        setErrorMessage(result.error ?? null);
        return;
      }

      navigate('/team-management', { replace: true, state: { message: 'User invited successfully. They will receive an email with instructions to set their password.' } });
    } catch (error) {
      console.error('Error creating user:', error);
      setErrorMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <div>
    <div className="main pb-4 d-flex flex-column align-items-center">
        <Button
        className="styled-button mb-4"
        onClick={() => navigate('/team-management')}
      >
        ← Back
      </Button>
      <h4 className="mb-6">Create a new team member</h4>

      <form onSubmit={handleSubmit} className="d-flex flex-column align-items-center">
        <TextField
          id="name"
          label="Name"
          variant="outlined"
          className="mb-4"
          value={name}
          style={{ minWidth: '300px' }}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <TextField
          id="role"
          label="Role"
          variant="outlined"
          className="mb-4"
          style={{ minWidth: '300px' }}
          value={role}
          onChange={(e) => setRole(e.target.value)}
          required
        />
        <TextField
          id="email"
          label="Email"
          variant="outlined"
          className="mb-4"
          style={{ minWidth: '300px' }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
         <FormControlLabel
          control={
            <Switch
              checked={isEnabled}
              onChange={(e) => setIsEnabled(e.target.checked)}
              color="primary"
            />
          }
          label="Enabled"
          className="mb-4"
        />
         <FormControlLabel
          control={
            <Switch
              checked={isLead}
              onChange={(e) => setIsLead(e.target.checked)}
              color="primary"
            />
          }
          label="Lead User"
          className="mb-4"
        />

        {errorMessage && (
          <div className="form-error mb-3">
            {errorMessage}
          </div>
        )}

        <Button type="submit" className="styled-button mb-4" id="btn-create-user">
          Create user
        </Button>
        <p>* denotes mandatory fields</p>
      </form>
    </div>
    </div>
  );
}

export default CreateUser;